import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { FileUploadModule } from 'primeng/fileupload';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { Richiesta } from '../../../models/richiesta.model';
import { DichiarazioneProntaRequest } from '../../../models/requests/dichiarazione-pronta.model';
import { RichiesteService } from '../../../services/richieste.service';
import { MessageService } from 'primeng/api';
import { NGXLogger } from 'ngx-logger';

@Component({
  selector: 'app-chiudi-preparazione-richiesta',
  templateUrl: './chiudi-preparazione-richiesta.component.html',
  styleUrls: ['./chiudi-preparazione-richiesta.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ButtonModule,
    DialogModule,
    FileUploadModule,
    InputTextareaModule
  ]
})
export class ChiudiPreparazioneRichiestaComponent implements OnInit {
  @Input() richiesta: Richiesta | null = null;
  @Output() finePreparazione = new EventEmitter<void>();

  visible: boolean = false;
  note: string = '';
  allegati: File[] = [];

  constructor(
    private richiesteService: RichiesteService,
    private messageService: MessageService,
    private logger: NGXLogger
  ) { }

  ngOnInit(): void {
  }

  show(richiesta: Richiesta) {
    this.richiesta = richiesta;
    this.visible = true;
  }

  hide() {
    this.visible = false;
    this.note = '';
    this.allegati = [];
  }

  onSelect(event: any) {
    this.allegati = event.files;
  }

  onRemove(event: any) {
    this.allegati = this.allegati.filter(file => file !== event.file);
  }

  save() {
    if (this.richiesta) {
      this.richiesteService.comunicaFinePreparazione(this.richiesta.id, this.note).subscribe({
        next: () => {

          this.finePreparazione.emit();
          this.hide();
        },
        error: (error) => {
          this.logger.error('[CHIUDI PREPARAZIONE] Errore durante la dichiarazione della richiesta:', error);
          this.messageService.add({
            severity: 'error',
            summary: 'Errore',
            detail: 'Si è verificato un errore durante la dichiarazione della richiesta'
          });
        }
      });

      return;
    }

   /*  const request: DichiarazioneProntaRequest = {
      note: this.note,
      allegati: this.allegati.map(file => ({
        nomeFile: file.name,
        percorsoFile: '', // Sarà impostato dal backend
        tipoFile: file.type,
        dimensioneKb: Math.round(file.size / 1024)
      }))
    }; */

    /*  */
  }
}
